<template>
  <div class="voucher-item-container">
    <div class="voucher-label">
      <v-icon size="16" color="rgba(0,0,0,0.45)">
        mdi-ticket-confirmation-outline
      </v-icon>
      <span>TRD No. ที่ทำรายการ Trade-in ไว้</span>
    </div>

    <div class="voucher-input-row">
      <v-text-field
        :value="value"
        :readonly="valid"
        :disabled="valid"
        :background-color="valid ? '#F2F2F2' : '#FFFFFF'"
        :error="!!errorMessage"
        :error-messages="!!errorMessage ? errorMessage : ''"
        :hide-details="!errorMessage"
        color="primary"
        outlined
        type="text"
        placeholder="TRDxxxx-xxxxx-xxxxxxxxxxxxxxxx"
        oninput="this.value = this.value.slice(0, 50).replace(/[^A-Za-z0-9-]+/g, '')"
        class="w-full"
        @input="$emit('input', $event)"
        @keypress.enter="$emit('confirm')"
      >
        <template v-slot:prepend-inner>
          <v-icon v-if="valid" color="#5bba47" size="20">
            mdi-check-circle-outline
          </v-icon>
        </template>
      </v-text-field>

      <v-btn
        icon
        text
        depressed
        class="btn-remove"
        @click="!!value ? $emit('confirmRemove') : $emit('remove')"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </div>

    <!-- <div v-if="errorMessage" class="voucher-error">
      <v-icon size="16" color="#FF4252">
        mdi-alert-circle-outline
      </v-icon>
      <span>{{ errorMessage }}</span>
    </div> -->

    <div
      v-if="amount !== null || branch !== null"
      class="voucher-info"
    >
      <div class="voucher-info-item">
        <div class="voucher-info-label">
          <v-icon size="16" color="rgba(0,0,0,0.45)">
            mdi-swap-horizontal-circle-outline
          </v-icon>
          <span>ราคา Trade-in</span>
        </div>
        <div
          class="voucher-info-value"
          :class="{
            '-is-pre-tradein': valid && type == TRADEIN_TYPE.TRADEIN,
            '-is-bntl': valid && type == TRADEIN_TYPE.BNTL,
          }"
        >
          <template v-if="valid && type == TRADEIN_TYPE.TRADEIN">
            ลดเลย!
          </template>
          {{ amount | currency }} บาท
        </div>
      </div>

      <div class="voucher-info-item">
        <div class="voucher-info-label">
          <v-icon size="16" color="rgba(0,0,0,0.45)">
            mdi-store-outline
          </v-icon>
          <span>สาขาที่ทำรายการ trade-in</span>
        </div>
        <div class="voucher-info-value">
          <v-icon v-if="branchError" size="16" color="#FF4252">
            mdi-alert-circle-outline
          </v-icon>
          {{ branchName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TRADEIN_TYPE } from '@/config/order'

export default {
  name: 'BaseTradeInVoucherItem',

  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    valid: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: [String, Number],
      default: null,
    },
    branch: {
      type: String,
      default: null,
    },
    branchName: {
      type: String,
      default: null,
    },
    branchError: {
      type: Boolean,
      default: false,
    },
    errorCode: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      TRADEIN_TYPE,
    }
  },

  methods: {
    onScanClick() {
      if (this.valid) return
      this.$emit('scan')
    },
  },
}
</script>

<style lang="stylus" scoped>
.voucher-item-container {
    display: flex;
    flex-direction: column;
    gap: 8px;

    padding: 16px;
	background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
}

.voucher-label {
    display: flex;
    align-items: center;
    gap: 6px;

    font-size: 14px;
    color: rgba(#000000, 0.85);
}

.voucher-input-row {
    display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 12px;

	@media screen and (min-width: 768px) {
		flex-direction: row;
    	align-items: flex-start;
	}
}

.voucher-error {
    display: flex;
    align-items: center;
    gap: 6px;

    font-size: 14px;
    color: #FF4252;
}

.voucher-info {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px 16px;
}

.voucher-info-label {
    display: flex;
    align-items: center;
    gap: 4px;

    font-size: 12px;
    color: rgba(#000000, 0.45);
    margin-bottom: 4px;
}

.voucher-info-value {
    display: flex;
    align-items: baseline;
    gap: 4px;

    font-size: 14px;
    font-weight: 700;
    color: rgba(#000000, 0.85);

    &.-is-pre-tradein {
        color: #1A7F37;
    }

	&.-is-bntl {
        color: #0071BC;
    }

    &.-is-error {
        color: #FF4252;
    }
}

::v-deep .v-btn.btn-remove {
    padding: 0 !important;
    min-width: 50px !important;
    color: rgba(0, 0, 0, 0.45) !important;
}
</style>
